/** @namespace JQuery */

/**
 * @param {JQuery} $element - The JQuery element to check
 * @param {Element} domElement - The DOM element to compare with
 * @returns {boolean} - Whether $element has or is domElement
 */
export const isOrHasDomElement = ($element, domElement) =>
    $element.has(domElement).length > 0 || $element.is(domElement);
